export default __webpack_public_path__ + "static/media/icon_tiktok.942e2767.svg";